import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AssinaturaDocumento } from 'src/app/pages/call-center/pages/projects/models/assinatura-documento';
import { Signatario } from 'src/app/pages/call-center/pages/projects/models/signatario';
import { AssinarDocumentoService } from 'src/app/pages/call-center/pages/projects/services/assinar-documento.service';
import { cpfCnpjValidator } from 'src/app/shared/Utils/cpf-cnpj.validator';
import { Location } from '@angular/common';
import { ToastService } from 'src/app/shared/toasts/toast-service';

@Component({
  selector: 'app-form-editar-contrato',
  templateUrl: './form-editar-contrato.component.html',
  styleUrl: './form-editar-contrato.component.scss'
})
export class FormEditarContratoComponent implements OnInit {
  breadCrumbItems!: Array<{}>;
  settingService = false;
  documentForm!: FormGroup;
  file: File | null = null;
  projetoId = "";

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private location: Location,
    private assinarDocumentoService: AssinarDocumentoService,
    private toastService: ToastService
  ) {
    this.documentForm = this.fb.group({
      nomeAssinaturaPrincipal: ["", [Validators.required]],
      emailAssinaturaPrincipal: ["", [Validators.required]],
      documentoAssinaturaPrincipal: ["", [Validators.required, cpfCnpjValidator]],
      tipoAssinaturaPrincipal: [1, [Validators.required]],

      nomeAssinatura02: [null],
      emailAssinatura02: [null],
      documentoAssinatura02: [null],
      tipoAssinatura02: [null],

      nomeAssinatura03: [null],
      emailAssinatura03: [null],
      documentoAssinatura03: [null],
      tipoAssinatura03: [null],

      document: [null, [Validators.required]]
    })
  }

  ngOnInit(): void {
    this.projetoId = this.route.snapshot.paramMap.get('id')!;

    this.breadCrumbItems = [
      { label: "Documentos" },
      { label: "Contrato", active: true },
    ];
  }

  onSubmit() {
    if (this.documentForm.invalid) {
      this.documentForm.markAllAsTouched();

      //Iterar sobre os campos e exibir os erros
      Object.keys(this.documentForm.controls).forEach((field) => {
        const control = this.documentForm.get(field);
        if (control?.errors) {
        }
      });

      return;
    }

    // Construindo lista de signatários
    const signatarios: Signatario[] = [];
    const formValue = this.documentForm.value;

    // Adiciona signatario principal
    signatarios.push({
      nome: formValue.nomeAssinaturaPrincipal,
      email: formValue.emailAssinaturaPrincipal,
      cpf: formValue.documentoAssinaturaPrincipal,
      tipoAssinatura: formValue.tipoAssinaturaPrincipal
    })

    //verifica para adicionar segundo signatario
    if (formValue.nomeAssinatura02 && formValue.emailAssinatura02 && formValue.documentoAssinatura02) {
      signatarios.push({
        nome: formValue.nomeAssinatura02,
        email: formValue.emailAssinatura02,
        cpf: formValue.documentoAssinatura02,
        tipoAssinatura: formValue.tipoAssinatura02
      });
    }

    //verifica para adicionar terceiro signatario
    if (formValue.nomeAssinatura03 && formValue.emailAssinatura03 && formValue.documentoAssinatura03) {
      signatarios.push({
        nome: formValue.nomeAssinatura03,
        email: formValue.emailAssinatura03,
        cpf: formValue.documentoAssinatura03,
        tipoAssinatura: formValue.tipoAssinatura03
      });
    }

    // Agora cria o objeto AssinaturaDocumento
    const assinaturaDocumento: AssinaturaDocumento = {
      // do tipo File
      documentoUuid: this.projetoId,
      signatarios: signatarios
    };


    // Enviando via FormData
    const formData = new FormData();
    formData.append('DocumentoId', assinaturaDocumento.documentoUuid);
    formData.append('SignatariosJson', JSON.stringify(assinaturaDocumento.signatarios));

    this.assinarDocumentoService.uploadArquivo(formData).subscribe({
      next: () => {
        this.toastService.show("Documento enviado sucesso", {
          classname: "bg-success text-light",
        });
      },
      error: () => {
        
        this.toastService.show("Erro ao atualizar projeto", {
          classname: "bg-danger text-light",
        });
      }
    });

    (formValue);
  }

  // Verifica se existe documento carregado
  onChange(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.file = file;
    }
  }

  hasContratoDocumentContrato(): boolean {
    return false;
  }

  downloadDocument(documentName: string): void {

    // let url = this.documents.find(doc => doc.nomeArquivo == documentName);

    // const a = document.createElement('a');
    // a.href = url?.urlDownload!;
    // a.download = `${documentName}_template.docx`;
    // a.click();
    // window.URL.revokeObjectURL(url?.urlDownload!);
  }

  openModal(documentName: string, documentType: number): void {
    // this.modalExcluirComponent.payload = { documentName, documentType };
    // this.modalExcluirComponent.openModal();
  }



  // Manipula valores do checkbox do tipo de assinatura
  selecionarTipo2(valor: number) {
    const atual = this.documentForm.value.tipoAssinatura02;
    this.documentForm.patchValue({
      tipoAssinatura02: atual === valor ? null : valor
    });
  }

  // Manipula valores do checkbox do tipo de assinatura
  selecionarTipo3(valor: number) {
    const atual = this.documentForm.value.tipoAssinatura03;
    this.documentForm.patchValue({
      tipoAssinatura03: atual === valor ? null : valor
    });
  }

  isChecked2(valor: number): boolean {
    return this.documentForm.value.tipoAssinatura02 === valor;
  }

  isChecked3(valor: number): boolean {
    return this.documentForm.value.tipoAssinatura03 === valor;
  }

  voltar() {
    this.location.back();
  }
}
